import { inject } from '@angular/core';
import { Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';

import { UserStore } from '@flashy/users/data-access';

export const dashGuardFn = (
  route: Route,
  segments: UrlSegment[]
): boolean | Observable<UrlTree> | UrlTree => {
  const userStore = inject(UserStore);
  const router = inject(Router);
  const link = sessionStorage.getItem('redirect')
    ? sessionStorage.getItem('redirect')
    : '/dash';
  if (segments[1]?.path === 'signout') {
    return from(userStore.signOut()).pipe(map(() => router.parseUrl('/auth')));
  }
  return userStore.needAuthentication()
    ? router.parseUrl('/verify')
    : !userStore.isAuthorized() || router.parseUrl(link);
};
